import React from "react"
import Layout from "../components/layout"
import { useIntl } from "gatsby-plugin-intl"
import "../sass/animate.css"
import { defaultIntl } from "../utils"
import Banner from "../includes/home/banner"
import About from "../includes/home/about"
import Advantage from "../includes/home/advantage"
import Downloads from "../includes/home/downloads"
import Partners from "../includes/home/partners"

const IndexPage = () => {
  const intl = useIntl() || defaultIntl;

  return (
    <Layout intl={intl} page="index">
      <Banner intl={intl} />
      <About intl={intl} />
      <Advantage intl={intl} />
      <Downloads intl={intl} />
      <Partners intl={intl} />
    </Layout>
    
  )
}

export default IndexPage
